import React from 'react';
import { Outlet, NavLink, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import GlobalSearch from './GlobalSearch';

const navStyle = (isActive) => ({
  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2,
  padding: '8px 6px', minWidth: 72, minHeight: 44, flex: '0 0 auto',
  color: isActive ? '#818cf8' : '#64748b',
  textDecoration: 'none', fontSize: 9,
  fontWeight: isActive ? 600 : 400, transition: 'color 0.2s',
});

const navDivider = { width: 1, background: '#334155', alignSelf: 'stretch', margin: '4px 2px', flexShrink: 0 };
const navGroup = { display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '0 4px 2px', fontSize: 7, color: '#334155', textTransform: 'uppercase', letterSpacing: 0.5, flexShrink: 0 };

export default function Layout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', flexDirection: 'column' }}>
      <header style={{ background: '#1e293b', borderBottom: '1px solid #334155', padding: '12px 16px',
        display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: '0 0 auto' }}>
          <span style={{ fontSize: 22 }}>📋</span>
          <span style={{ fontWeight: 700, fontSize: 16, color: '#f1f5f9' }}>Vertragsmanager</span>
        </div>
        <GlobalSearch />
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 'auto', flex: '0 0 auto' }}>
          <Link to="/profil" style={{ color: '#64748b', fontSize: 13, textDecoration: 'none' }}
            title="Profil bearbeiten">{user?.name || user?.email}</Link>
          <button onClick={handleLogout} className="btn-secondary">Abmelden</button>
        </div>
      </header>
      <main style={{ flex: 1, padding: '0 0 80px 0', overflowY: 'auto' }}><Outlet /></main>
      <nav style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: '#1e293b',
        borderTop: '1px solid #334155', display: 'flex', justifyContent: 'flex-start', alignItems: 'stretch', gap: 0,
        overflowX: 'auto', paddingBottom: 'env(safe-area-inset-bottom)', zIndex: 50 }}>

        {/* ARBEIT */}
        <div style={navGroup}>ARBEIT</div>
        <NavLink to="/" end style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📊</span>Dashboard</NavLink>
        <NavLink to="/actions" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🎯</span>Actions</NavLink>
        <NavLink to="/benachrichtigungen" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🔔</span>Erinnerungen</NavLink>
        <NavLink to="/simulation" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>💶</span>Simulator</NavLink>
        <NavLink to="/kontoauszuege" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🏦</span>Kontoauszüge</NavLink>
        <NavLink to="/posteingang" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📥</span>Posteingang</NavLink>
        <NavLink to="/paperless" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📄</span>Paperless</NavLink>
        <NavLink to="/radar" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📡</span>Radar</NavLink>
        <NavLink to="/vergleich" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>⚖️</span>Vergleich</NavLink>
        <NavLink to="/optimierung" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>💡</span>Optimierung</NavLink>
        <NavLink to="/aufgaben" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>✅</span>Aufgaben</NavLink>
        <NavLink to="/kalender" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📅</span>Kalender</NavLink>

        <div style={navDivider} />

        {/* VERTRÄGE */}
        <div style={navGroup}>VERTRÄGE</div>
        <NavLink to="/vertraege" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📋</span>Verträge</NavLink>
        <NavLink to="/dokumente" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📄</span>Dokumente</NavLink>
        <NavLink to="/pruef-center" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🔍</span>Prüfen</NavLink>
        <NavLink to="/wissensbasis" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🧠</span>Wissen</NavLink>
        <NavLink to="/kuendigungen" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>⏰</span>Kündigung</NavLink>

        <div style={navDivider} />

        {/* ORGANISATION */}
        <div style={navGroup}>ORGANISATION</div>
        <NavLink to="/anbieter" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🏢</span>Anbieter</NavLink>
        <NavLink to="/kontakte" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>👤</span>Kontakte</NavLink>
        <NavLink to="/kommunikation" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>✉️</span>Komm.</NavLink>
        <NavLink to="/kosten" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>💳</span>Kosten</NavLink>

        <div style={navDivider} />

        {/* SYSTEM */}
        <div style={navGroup}>SYSTEM</div>
        <NavLink to="/suche" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🔎</span>Suche</NavLink>
        <NavLink to="/import" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📥</span>Import</NavLink>
        <NavLink to="/export" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📤</span>Export</NavLink>
        <NavLink to="/automatisierungen" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>⚙️</span>Automation</NavLink>
        <NavLink to="/einstellungen" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🛠️</span>Einst.</NavLink>

        <div style={navDivider} />

        {/* WEITERE (bestehend) */}
        <div style={navGroup}>MEHR</div>
        <NavLink to="/assistant" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🤖</span>KI</NavLink>
        <NavLink to="/zahlungen" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>💸</span>Zahlungen</NavLink>
        <NavLink to="/ausgaben" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>💰</span>Ausgaben</NavLink>
        <NavLink to="/haushalt" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>🏦</span>Haushalt</NavLink>
        <NavLink to="/reports" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>📑</span>Reports</NavLink>
        <NavLink to="/gesundheit" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: 18 }}>💚</span>Gesundheit</NavLink>
      </nav>
    </div>
  );
}
